import React from 'react'
import PropTypes from 'prop-types'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Deal.style'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import NumericFormatModal from '../../../../components/ModalApp/components/NumericFormatModal/NumericFormatModal'
import { Label } from '../../../../components/styled/global.style'
import { Box, Typography } from '@mui/material'
import {
  ButtonGroupStyle,
  OptionContainer,
  OptionCounterparty,
  PutCallButton,
  SideButton
} from '../../Deal.style'
import FlagCurrency from '../../../../components/FlagCurrency/FlagCurrency'
import CurrencyLogo from '../../../../components/CurrencyLogo/CurrencyLogo'

const VanillaDealClientSide = ({
  clients,
  sides,
  putCall,
  cut,
  fixingSource,
  currencyData,
  form,
  currencyInitial,
  handelFormChange,
  handelDateChange,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair,
  children,
  disabledField,
  errors,
  tradingAccountTradersNormalize
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Trade Type *</Label>
        <InputBaseStyle value={`Client ${form.deal_type.name}`} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Client *</Label>
        {Array.isArray(clients.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'client'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.client}
            options={clients.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select Client'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Client Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="client_side"
                key={id}
                value={name}
                select={String(form.client_side === name)}
                onClick={handelFormChange}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Put/Call *</Label>
        {Array.isArray(putCall) && (
          <ButtonGroupStyle variant="outlined">
            {putCall.map(({ name }, id) => (
              <PutCallButton
                name="put_call"
                key={id}
                value={name}
                disabled={disabledField.put_call}
                select={String(form.put_call === name)}
                onClick={handelFormChange}
              >
                {name}
              </PutCallButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Expiry Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.expiry}
          onChange={event => handelDateChange('expiry', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <NumericFormatModal
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Strike Price *</Label>
        <InputBaseStyle
          value={form.strike}
          name="strike"
          disabled={disabledField.strike}
          onChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Cut *</Label>
        {Array.isArray(cut.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'cut'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.cut}
            options={cut.data.map(({ cut }) => cut)}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Cut" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Settlement Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.settlement_date}
          onChange={event => handelDateChange('settlement_date', event.target.value)}
        />
      </Box>

      <Box width={'100%'}>
        <Label>Fixing Source </Label>
        {Array.isArray(fixingSource.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'fixing_source'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            disabled={disabledField.fixing_source}
            size={'small'}
            value={form.fixing_source}
            options={fixingSource.data.map(({ name }) => name)}
            renderInput={params => (
              <TextFieldModalStyle
                fullWidth
                {...params}
                placeholder="Select Fix Source"
                disabled={disabledField.fixing_source}
              />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Premium Currency *</Label>
        {Array.isArray(currencyData.data) && (
          <AutocompleteStyle
            fullWidth
            onChange={(event, element) => {
              event.target.name = 'client_premium_currency'
              element = element ?? currencyInitial
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.client_premium_currency}
            getOptionLabel={option => option.name}
            options={currencyData.data}
            renderOption={(props, option) => (
              <OptionContainer {...props} key={option.id}>
                <FlagCurrency countryCode={option.code3} />
                <CurrencyLogo currencyCode={option.name} />
                <Typography>{option.name} </Typography>
              </OptionContainer>
            )}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Currency" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Premium Amount *</Label>
        <InputBaseStyle
          value={form.client_premium_amount}
          name="client_premium_amount"
          onChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Premium Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.client_premium_date}
          onChange={event => handelDateChange('client_premium_date', event.target.value)}
        />
      </Box>

      <Box width={'100%'}>
        <Label>Trader </Label>
        {tradingAccountTradersNormalize.status === 200 && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'client_trader_name'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.client_trader_name}
            getOptionLabel={option => option}
            disabled={
              form.client === '' ||
              !Array.isArray(tradingAccountTradersNormalize.data[form.client]) ||
              tradingAccountTradersNormalize.data[form.client].length === 0
            }
            options={
              form.client !== '' && Array.isArray(tradingAccountTradersNormalize.data[form.client])
                ? tradingAccountTradersNormalize.data[form.client].map(trader_name => trader_name)
                : []
            }
            renderInput={params => (
              <TextFieldModalStyle {...params} fullWidth placeholder="Select Trader" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Client Note</Label>
        <InputBaseStyle value={form.client_note} name="client_note" onChange={handelFormChange} />
      </Box>
      {children}
    </>
  )
}

export default VanillaDealClientSide

VanillaDealClientSide.propTypes = {
  clients: PropTypes.object,
  sides: PropTypes.object,
  putCall: PropTypes.array,
  cut: PropTypes.object,
  fixingSource: PropTypes.object,
  currencyData: PropTypes.object,
  tradingAccountTradersNormalize: PropTypes.object,
  currencyInitial: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelDateChange: PropTypes.func,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  form: PropTypes.object,
  disabledField: PropTypes.object,
  errors: PropTypes.object,
  children: PropTypes.node
}
